<template>
  <div class="project">
    <div class="content">
      <img src="../assets/special.png">
      <div>
          <table style="">
            <thead style="">
               <th style="width:560px;border-top-left-radius: 16px;">项目名称</th>
               <th style="width:186px;">引额</th>
               <th style="border-top-right-radius: 16px;">操作</th>
            </thead>
            <tbody>
               <!--<tr>
                 <td style="width:560px;padding-left:20px;text-align:left;font-weight:bold;">四川富润下属四川玻纤集团有限公司上市股改项目</td>
                 <td style="width:186px;">2-3亿</td>
                 <td style=""><a target="_blank" href="">查看详情</a></td>
               </tr>
               <tr>
                 <td style="width:560px;padding-left:20px;text-align:left;font-weight:bold;">四川川商集团下属四川省数字经济产业发展有限责任公司增资扩股</td>
                 <td>1.6亿</td>
                 <td><a target="_blank" href="">查看详情</a></td>
               </tr>-->
               <tr>
                 <td style="width:560px;padding-left:20px;text-align:left;font-weight:bold;">
                   <a target="_blank" href="http://www.swuee.com/dist/index.html#/roadShowDetail?id=5">锦泰财产保险股份有限公司增资扩股</a>
                 </td>
                 <td>26亿</td>
                 <td><a target="_blank" href="http://www.swuee.com/dist/index.html#/roadShowDetail?id=5">查看详情</a></td>
               </tr>
               <tr style="border-bottom-left-radius: 16px;border-bottom-right-radius: 16px;">
                 <td style="width:560px;padding-left:20px;text-align:left;font-weight:bold;">
                   <a target="_blank" href="http://www.swuee.com/dist/index.html#/roadShowDetail?id=15">广元中小企业金融服务（集团）有限公司增资扩股</a>
                 </td>
                 <td>3亿</td>
                 <td><a target="_blank" href="http://www.swuee.com/dist/index.html#/roadShowDetail?id=15">查看详情</a></td>
               </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../style/project-detail.css";
</style>

<script>
  import { mapState } from 'vuex'
  import global from '../components/public/Common.vue';

  export default {
    name: 'author',
    computed: {
      // ...mapState({
      //   author: state => state.AuthorStore.author,
      //   other: state => state.AuthorStore.other,
      //   pathName: state => state.SelectStore.pathName
      // })
    },
    data() {
      return {
        assets: '',
      }
    },
    created: function () {
      let _this = this;
      //_this.$emit('header',false);//控制不显示头部
    },
    mounted:function(){
      let _this = this;

    },
    watch: {
      //'$route': 'fetchData'
    },
    methods: {

    },
    filters: {
      dateFormat:function(time) {
        return global.dateFormatYmdhms(time)
      },
      priceFormat:function(price) {
        return global.priceFormat(price)
      }
    },
  }
</script>

<style lang="stylus">
table{
  width:960px;margin:0 auto;border-spacing: 0;border-collapse: collapse;
  font-family: "Microsoft YaHei",sans-serif;
  font-family: "Microsoft YaHei",serif;
}
table thead{
  background:#e5e5e5;
  font-weight:normal;
  height:44px;
  line-height:44px;
  /*border:1px solid #e5e5e5;*/
  border-radius:16px;
}
table thead th{
  font-weight:normal;
}
table tbody tr{
  cursor:pointer;
  border:1px solid #e5e5e5;
}
table tbody tr:hover{
   color:#1A59A1;
}
table tbody tr:hover td a{
  color:#1A59A1;
}
table tbody tr td{
  height:50px;
  line-height 50px;
  text-align:center;
}
table tbody tr td a{
  color:#333;
  text-decoration:none;
}
</style>



// WEBPACK FOOTER //
// src/components/Special.vue